import { useEffect } from "react";

// Adds the "is-visible" class to every [data-reveal] element as it scrolls into view.
export default function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll("[data-reveal]");
    if (typeof window.IntersectionObserver !== "function") {
      els.forEach((el) => el.classList.add("is-visible"));
      return undefined;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}
